import { sendLeadDataToApi } from '@shared/shared-api';
import { type HCPFormType } from '../types/hcp-form.type';

const sendHcpFormData = (data: HCPFormType) => {
  return sendLeadDataToApi('organogenesis_physician_finder', data);
};

export { sendHcpFormData };
